import createAttachmentFromUriOperation from 'owa-service/lib/operation/createAttachmentFromUriOperation';
import { getDefaultRequestOptions } from 'owa-headers';
import { ClientItemId } from 'owa-client-ids';

export default async function createAttachmentFromUri(
    parentItemId: ClientItemId,
    uri: string,
    name: string,
    subscriptionId: string,
    isInline: boolean,
    contentId: string
): Promise<string> {
    const requestOptions = (await getDefaultRequestOptions(parentItemId.mailboxInfo)) || {};
    return await createAttachmentFromUriOperation(
        {
            itemId: parentItemId,
            uri,
            name,
            subscriptionId,
            isInline,
            contentId,
        },
        requestOptions
    );
}
